import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth/AuthProvider';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { loadThemePreference, applyThemePreference } from './state/theme';
import './index.css';
import './lib/appInsights'; // side-effect: initializes AI

applyThemePreference(loadThemePreference());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);

// Global unhandled error/rejection → AI exception
window.addEventListener('error', (e) => {
  import('./lib/appInsights').then(({ appInsights }) => {
    appInsights?.trackException({ exception: e.error ?? new Error(e.message) });
  });
});
window.addEventListener('unhandledrejection', (e) => {
  import('./lib/appInsights').then(({ appInsights }) => {
    appInsights?.trackException({ exception: e.reason instanceof Error ? e.reason : new Error(String(e.reason)) });
  });
});
